import styled, { css } from 'styled-components';
import { above } from './utilities';

export const Grid = styled.div`
  ${({ cols }) => css`
    display: block;
    ${above.small`
      display: grid;
      --gridCols: ${cols || 4};
      grid-template-columns: var(--gridCols);
      grid-template-columns: repeat(var(--gridCols), 1fr);
    `}
  `};
`;
